import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { AppState } from './store'

interface personalDateSlice {
  from: string | null
  to: string | null
}

// null = användaren har inte valt datum ännu → vyn faller tillbaka på senaste körningens månad (#47).
// När ett datum väljs (eller seedas) lagras det här och bibehålls vid navigering.
const initialState = {
  from: null,
  to: null,
} as personalDateSlice

const personalDateSlice = createSlice({
  name: 'personalDate',
  initialState,
  reducers: {
    setPersonalDate(state, action: PayloadAction<personalDateSlice>) {
      return action.payload
    },
  },
})

export const getPersonalDateFrom = (state: AppState) => state.personalDateReducer.from
export const getPersonalDateTo = (state: AppState) => state.personalDateReducer.to
export const { setPersonalDate } = personalDateSlice.actions
export default personalDateSlice.reducer
